import React, { Component } from "react";
import EditableTreeItem from "./EditableTreeItem";
import { TYPE } from "helper/Validator/ValidatorFieldBuilder";
import { Strings } from "config/Strings";

export default class ComponentItem extends Component {
  fields = [
    {
      label: Strings.getInstance().getString("preferences_component_name"),
      name: "name",
      type: TYPE.ANY,
      style: { flex: 1 },
    },
  ];

  render() {
    return <EditableTreeItem nodeId={this.props.nodeId} data={this.props.data} fields={this.fields} {...this.props} />;
  }
}
